import { render } from "./Webentity.vue?vue&type=template&id=3f68f339"
import script from "./Webentity.vue?vue&type=script&lang=js"
export * from "./Webentity.vue?vue&type=script&lang=js"

import "./Webentity.vue?vue&type=style&index=0&id=3f68f339&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__